module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con01"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "pro_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/pro01#pro01"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("In Highgate, north London, Vanessa Fitzgerald, accounts manager at Gibson,…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch01"
    }
  }, [_vm._v("Chapter 1")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Jo Green’s eyes glazed over as she stared at the…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('a', {
    attrs: {
      "href": "#/ch02#ch02"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("There was so much to take in, Jo didn’t know…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("“Leaving?” repeated Hilda. “What do you mean? Leaving?”")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("When Jo’s train pulled out of Stratford-upon-Avon station she was…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Jo could probably have coped with the wake-up call of…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("A fortnight later, back in Niblet, Shaun reached the pub…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("On Sunday morning Jo discovered that all advice from her…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("When Jo’s head hit the pillow, she was out for…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Jo’s head hurt so much the next morning that her…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Over the next week, Jo discovered that the average accountant…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Vanessa sat in the Monday morning status meeting hunched over…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_12"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("It was teatime and Jo had invited Pippa and Georgiana…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Shaun was visiting that weekend, so Jo would be unable…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Saturday morning, Jo woke early. She listened intently for any…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Jo woke early on Monday morning, aware that Josh would…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("By the time Jo was rounding up the children for…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Saturday morning, Vanessa woke to feel someone gently stroking her…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Jo was awake before six. She stared at Mickey and…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Jo was so busy in her first week at home…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Monday morning came bright and breezy. Hilda had come downstairs…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_21"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("It was another few days before Sheila finally returned her…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_22"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Stupidly early on the Monday morning of her fifth week…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_23"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Josh woke early the next morning and found the kids…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_24"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Josh was so livid he could barely drive out of…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_25"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("The next morning, Jo stood in her bedroom, checking her…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_26"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Things at the Fitzgeralds’ abode were changing fast. Josh and…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_27"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Lunchtime a week later, Sebastian James sat bulkily on top…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_28"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("On Friday afternoon, Cassie made a moving-out card with Zak…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_29"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Next morning, Jo’s brain was Pot Noodle. The first thing…")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "ch_30"
    }
  }, [_c('p', {
    staticClass: "contentsEntryNumber"
  }, [_c('span', {
    attrs: {
      "href": "#/ch30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30")])]), _vm._v(" "), _c('p', {
    staticClass: "contentsEntryName"
  }, [_vm._v("Toby carried four choc-ices upstairs and waited outside Tallulah’s bedroom…")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "ata_1"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/ata1#ata1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "adc_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/adc01#adc01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Others Books by Melissa Nathan")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "cop_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/cop01#cop01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "atp_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/atp01#atp01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0